import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

interface Props {
  mode: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'MasterMaintenanceMenuList',
  props: {
    mode: {}
  },
  setup(__props: any) {



const MODE_TYPE = {
  SIDE: 'side',
  TILE: 'tile',
};

return (_ctx: any,_cache: any) => {
  const _component_q_item = _resolveComponent("q-item")!
  const _component_q_separator = _resolveComponent("q-separator")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_list = _resolveComponent("q-list")!
  const _directive_ripple = _resolveDirective("ripple")!

  return (_openBlock(), _createBlock(_component_q_list, {
    class: _normalizeClass('master-maintenance ' + (_ctx.mode === MODE_TYPE.SIDE ? 'listed' : 'tiled'))
  }, {
    default: _withCtx(() => [
      (_ctx.mode === MODE_TYPE.SIDE)
        ? (_openBlock(), _createBlock(_component_q_item, {
            key: 0,
            class: "master-maintenance-item"
          }, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createElementVNode("span", { class: "q-mini-drawer-hide" }, "マスタメンテナンス", -1)
            ])),
            _: 1
          }))
        : _createCommentVNode("", true),
      (_ctx.mode === MODE_TYPE.SIDE)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 1 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mode === MODE_TYPE.TILE ? 'row q-mb-lg' : '')
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'sdfile' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[1] || (_cache[1] = [
                _createTextVNode("SDFile一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'sdfileRegist' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[2] || (_cache[2] = [
                _createTextVNode("SDFile登録")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ], 2),
      (_ctx.mode === MODE_TYPE.TILE)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 2 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mode === MODE_TYPE.TILE ? 'row q-mt-lg q-mb-lg' : '')
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'stockPrice' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[3] || (_cache[3] = [
                _createTextVNode("在庫価格ファイル取込")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'exchangeRate' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("為替レート設定")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'CoefficientSetting' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode("円転後仕入価格帯別係数設定")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ], 2),
      (_ctx.mode === MODE_TYPE.TILE)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 3 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mode === MODE_TYPE.TILE ? 'row q-mt-lg q-mb-lg' : '')
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'attoId' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode("ATTOID一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'catalog' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[7] || (_cache[7] = [
                _createTextVNode("商品情報一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ], 2),
      (_ctx.mode === MODE_TYPE.TILE)
        ? (_openBlock(), _createBlock(_component_q_separator, { key: 4 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(_ctx.mode === MODE_TYPE.TILE ? 'row q-mt-lg q-md-lg' : '')
      }, [
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'supplier' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[8] || (_cache[8] = [
                _createTextVNode("サプライヤ一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'customer' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[9] || (_cache[9] = [
                _createTextVNode("得意先および掛け率一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'deliveryTime' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[10] || (_cache[10] = [
                _createTextVNode("納期一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ]),
        _withDirectives((_openBlock(), _createBlock(_component_q_item, {
          clickable: "",
          to: { name: 'news' }
        }, {
          default: _withCtx(() => [
            _createVNode(_component_q_item_section, null, {
              default: _withCtx(() => _cache[11] || (_cache[11] = [
                _createTextVNode("お知らせ一覧")
              ])),
              _: 1
            })
          ]),
          _: 1
        })), [
          [_directive_ripple]
        ])
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})